import _ from 'lodash';
import React, {Component } from 'react';
import PropTypes from 'prop-types';
//import moment from 'moment-timezone';

//- Material UI / Style
import { withStyles } from '@material-ui/core/styles';

//containers
import AuthUserContainer from '../../containers/AuthUser';
import TicketCategoryContainer from '../../containers/Ticket/TicketCategory';

//- UI / Form
import FormSubmitButton from '../../components/form/FormSubmitButton';

import ParentTicketCategoryPicker from "../../components/advancedForm/ParentTicketCategoryPicker";
import TicketSchemaPicker from "../../components/advancedForm/TicketSchemaPicker";
import FormText from "../../components/form/FormText";
import FormContainer from "../../components/FormContainer";
import UserPicker from "../../components/advancedForm/UserPicker";
import SectionHeader from "../../components/SectionHeader";
import FormSelect from "../../components/form/FormSelect";
import FormTypeToSelect from "../../components/form/FormTypeToSelect";

const styles = () => {
	return {};
};

const idField = 'ticketCategoryId';
const itemDisplay = 'Ticket Category';

class SaveTicketCategory extends Component {
	constructor(props) {
		super(props);

		const action = _.get(this.props, 'match.params.action');
		const id = parseInt(_.get(this.props, `match.params.${idField}`), 10);
		const isUpdate = (action === 'update');

		this.state = {
			isUpdate,
			[idField] : id,
			formFieldError: {},
		};
	}

	componentDidMount () {
		const {ticketCategory, getTicketCategory} = this.props;
		const {ticketCategoryId, isUpdate} = this.state;
		if (!isUpdate) { return; }

		if (ticketCategory) {
			this.fillForm({ticketCategory});
		} else {
			getTicketCategory({
				params: {ticketCategoryIds: [ticketCategoryId]}
			});
		}
	}

	componentDidUpdate(prevProps, prevState, snapShot) {
		const { ticketCategory } = this.props;

		if (_.isUndefined(prevProps.ticketCategory) && !_.isUndefined(ticketCategory)) {
			this.fillForm({ ticketCategory });
		}
	}

	fillForm = ({ ticketCategory }) => {
		if (!ticketCategory) { return; }

		const newState = {};
		[
			'displayName',
			'ticketSchemaId',
			'defaultAssignedToUserId',
			'defaultUserIdsToCc',
			'assignToType',
			'defaultFleetUsersToCc',
		].forEach(key => {
			if (_.isNil(ticketCategory[key])) { return; }
			newState[key] = ticketCategory[key];
		});

		const { parentTicketCategoryIds } = ticketCategory;

		newState.parentTicketCategoryId = _.first(parentTicketCategoryIds);
		this.setState(newState);
	};

	onChange = (value, path, error) => {
		const arrayPath = _.toPath(path);
		const basePath = _.head(arrayPath);
		let base = this.state[basePath];
		let newState = {};

		if (_.isArray(base) || _.isObject(base)) {
			if (arrayPath.length > 1) {
				base = _.cloneDeep(base);
				_.set(base, arrayPath.slice(1), value);
				newState[basePath] = base;
			} else {
				newState[basePath] = value;
			}
		} else {
			newState[basePath] = value;
		}

		//- Clear any errors on the path
		let formFieldError = Object.assign({}, this.state.formFieldError);

		if (error) {
			formFieldError[path] = error;
		} else {
			delete formFieldError[path];
		}
		newState.formFieldError = formFieldError;
		this.setState(newState);
	};

	handleSave = () => {
		const {
			addTicketCategory,
			updateTicketCategory,
			showErrors,
		} = this.props;

		const {isUpdate, ticketCategoryId} = this.state;

		const formFieldError = {};

		const requiredFields = [
			{path: 'displayName', label: 'Category Name'},
			{path: 'ticketSchemaId', label: 'Ticket schema'},
			{path: 'parentTicketCategoryId', label : 'Parent ticket category'},
			{path: 'assignToType', label : 'Assign to type'},
		];

		requiredFields.forEach(({path, label})=> {
			if (!this.state[path]) {
				formFieldError[path] = `${label} is required`;
			}
		});

		//- Get all the values and do individual checks
		if (_.keys(formFieldError).length) {
			this.setState({formFieldError});
			showErrors(_.values(formFieldError));
			return;
		}

		const {
			displayName,
			ticketSchemaId,
			parentTicketCategoryId,
			assignToType,
			defaultAssignedToUserId,
			defaultUserIdsToCc,
			defaultFleetUsersToCc,
		} = this.state;


		const params = {
			displayName,
			ticketSchemaId,
			parentTicketCategoryId,
			assignToType,
			defaultAssignedToUserId,
			defaultUserIdsToCc,
			defaultFleetUsersToCc,
		};

		if (!isUpdate) {
			addTicketCategory({
				params,
			});
		} else {
			params.ticketCategoryId = ticketCategoryId;
			updateTicketCategory({
				params,
			});
		}
	};

	getInputProps = (path, defaultValue) => {
		return {
			key : path,
			path,
			value  : this.getValue(path, defaultValue),
			checked  : this.getValue(path, defaultValue),
			error : this.getError(path),
			onChange : this.onChange,
			gridProps : { md : 12 },
		};
	};

	getValue  = (path, defaultValue) => {
		const _d = (_.isUndefined(defaultValue)) ? '' : defaultValue;
		return _.get(this.state, path, _d);
	};

	getError = (path) => {
		return _.get(this.state.formFieldError, path);
	};

	render () {
		const {
			permissions,
		} = this.props;

		const {
			isUpdate,
			assignToType,
		} = this.state;

		if (!permissions || !_.includes(permissions,'canAddAndUpdateTicketSettings')) {
			return (<div>You do not have valid permissions to view this page.</div>);
		}

		const action = (isUpdate) ? 'Update' : 'Create';
		return (<FormContainer headline={`${action} ${itemDisplay}`}>

				<SectionHeader label={'Info'} gridProps={{md : 12 }} />

				<FormText
					label={'Category Name'}
					{...this.getInputProps('displayName')}
				/>

				<ParentTicketCategoryPicker
					label={'Parent ticket category'}
					{...this.getInputProps('parentTicketCategoryId')}
				/>

				<TicketSchemaPicker
					label={'Ticket schema to use'}
					{...this.getInputProps('ticketSchemaId')}
				/>

				<SectionHeader label={'Ticket Assignment'} gridProps={{md : 12 }} />

				<FormSelect
					{...this.getInputProps('assignToType')}
					label={'Assignment Type'}
					options={[
						{ display : 'Assign to User' , value : 'defaultAssignedToUserId' },
						{ display : 'Terminal Manager for Fleet' , value : 'terminalManagerForFleet' }
					]}
				/>

				{assignToType === 'defaultAssignedToUserId' &&
				<UserPicker
					{...this.getInputProps('defaultAssignedToUserId')}
					label={'Default employee to assign new tickets to'}
					whoToShow={'nonDriversOnly'}
				/>
				}

				<SectionHeader label={'Ticket CC List'} gridProps={{md : 12 }} />
				<UserPicker
					{...this.getInputProps('defaultUserIdsToCc')}
					label={'Default employees to CC on new tickets'}
					whoToShow={'nonDriversOnlyWithEmailGroups'}
					selectMultiple={true}
				/>

				<FormTypeToSelect
					{...this.getInputProps('defaultFleetUsersToCc')}
					label={'Default fleet users to CC on new tickets'}
					options={[
						{ label : 'Terminal manager for fleet' , value : 'terminalManagerForFleet' },
						{ label : 'Terminal admin for fleet' , value : 'terminalAdminForFleet' },
						{ label : 'Mechanical group for fleet' , value : 'mechanicalGroupForFleet' },
					]}
					selectMultiple={true}
				/>

				<FormSubmitButton
					onClick={this.handleSave}
					buttonText={`${action} ${itemDisplay}`}
				/>
		</FormContainer>);
	}
}

SaveTicketCategory.propTypes = {
	getTicketCategory : PropTypes.func.isRequired,
	addTicketCategory : PropTypes.func.isRequired,
	updateTicketCategory : PropTypes.func.isRequired,
	ticketCategory : PropTypes.object,

	showErrors : PropTypes.func.isRequired,
	authUser : PropTypes.object,
	classes: PropTypes.object.isRequired,
};

export default _.flow([
	withStyles(styles),
	AuthUserContainer,
	TicketCategoryContainer,
])(SaveTicketCategory);
